// extracted by mini-css-extract-plugin
export default {"comments":"LockAvailabilityButton_comments__VsZsn","suspendMenu":"LockAvailabilityButton_suspendMenu__ExUN3"};